import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ExternalCashoutPage } from './external-cashout';

@NgModule({
  declarations: [
    ExternalCashoutPage,
  ],
  imports: [
    IonicPageModule.forChild(ExternalCashoutPage),
  ],
})
export class ExternalCashoutPageModule {}



// WEBPACK FOOTER //
// ./src/pages/external-cashout/external-cashout.module.ts